<template>
  <div class="container">
    <div class="cloud-box" ref="cloudEl" />
  </div>
</template>

<script>
import * as echarts from "echarts";
import wordcloud from "echarts-wordcloud";
export default {
  name: "Analysis",
  data() {
    return {
      wordcloud: wordcloud,
      wordData: [
        { name: "Vue", value: 100 },
        { name: "JavaScript", value: 80 },
        { name: "CSS", value: 70 },
        { name: "JAVA", value: 170 },
        { name: "php", value: 30 },
        { name: "C#", value: 20 },
        { name: "周全", value: 90 },
        { name: "澎湃", value: "25" },
        { name: " 暴晒", value: " 14" },
        { name: " 套件", value: "13" },
        { name: " 有", value: " 24" },
        { name: " 驾驶", value: " 30" },
        { name: " 满满", value: " 1" },
        { name: " 行驶", value: " 2" },
        { name: " 强烈", value: "3" },
        { name: " 轻盈", value: "8" },
        { name: " 沉稳", value: "5" },
        { name: " 1800公里", value: " 1" },
      ],
    };
  },
  mounted() {
    this.drawCloud(this.$refs.cloudEl, this.wordData);
  },

  methods: {
    drawCloud(wrapEl, data) {
      let myChart = echarts.init(wrapEl);
      var option = {
        tooltip: {
          show: true,
        },
        series: [
          {
            type: "wordCloud",
            sizeRange: [10, 30],
            rotationRange: [-20, 20],
            shape: "circle",
            left: "center",
            top: "center",
            width: "100%",
            height: "80%",
            gridSize: 10,
            textPadding: 0,

            textStyle: {
              color: function () {
                return "rgb(" + Math.round(Math.random() * 255) + "," + Math.round(Math.random() * 255) + "," + Math.round(Math.random() * 255) + ")";
              },
            },
            data: data,
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  .cloud-box {
    width: 490px;
    height: 400px;
  }
}
</style>
